<template>
  <div class="rent-search-wrapper">
    <v-container>
      <v-row>
        <v-col>
          <span>
            <v-btn v-if="location" text color="blue" @click="goToCourse">
              {{ location.title }}
            </v-btn>
          </span>
          
          <span> | </span>
          
          <span>
            <v-btn text color="blue" @click="goToCourse">
              {{ checkInDateFormated }}
            </v-btn>
          </span>

        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col>
          <v-chip-group v-model="schoolCategory" mandatory active-class="primary accent-4" column>
            <v-chip v-for="category in schoolCategories" :key="category.id" label x-large>
              {{ category.title }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col v-for="product in products" :key="product.id" cols="12" sm="4" md="4">
          <course-product-card v-bind:product="product" v-on:bookProduct="bookProduct(product)"></course-product-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import moment from "moment";
import CourseProductCard from "@/components/CourseProductCard";

export default {
  components: {
    CourseProductCard
  },

  metaInfo: {
    title: "Lyzarska skola",
  },

  data() {
    return {
      schoolCategory: 0,
    };
  },

  async mounted() {
    console.log("mounted");

    if (
      this.$store.state.location == null ||
      this.$store.state.appInstance == null ||
      this.$store.state.checkInDate == null
    ) {
      console.log("Nesplnene prerekvizity");
      this.$router.push({ name: "course" });
    } else {
      this.init();
    }
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    currentOrderr() {
      return this.$store.state.currentOrderr;
    },

    location() {
      return this.$store.state.location;
    },

    checkInDate() {
      return this.$store.state.checkInDate;
    },

    checkInDateFormated() {
      if(this.checkInDate == null) {
        return "";
      }
      return moment(this.checkInDate).format("D. M. YYYY");
    },

    schoolCategories() {
      return this.$store.state.schoolCategories;
    },

    products: function() {
      try {
        console.log("produkty na ceste");
        let productsFiltered = [];
        let products = this.$store.state.schoolCategories[this.schoolCategory].products.items;
        for (let i = 0; i < products.length; i++) {
          let product = products[i];
          //console.log(i);
          //console.log(product);
          //let loc = product.locations.items.filter((l) => l.location.id === this.location.id);
          //console.log(loc);
          // if (loc.length > 0) {
          //   productsFiltered.push(product);
          // }
          productsFiltered.push(product);
        }
        return productsFiltered;
      } catch (error) {
        console.log("products jeste nejsou k dispozici");
        return [];
      }
    },
  },

  methods: {
    init() {
      this.$store.dispatch("loadListCategoriesAndProductsSchool", {});
    },

    goToCourse() {
      this.$router.push({ name: "course" });
    },

    bookProduct(product) {
      console.log("bookProduct");
      console.log(product);
      
      if(product.schoolFormType == 'PRIVATE') {
        this.$router.push({
          name: "course-private-booking",
          params: { productId: product.id },
        });
      } else if(product.schoolFormType == 'GROUP') {
        this.$router.push({
          name: "course-group-booking",
          params: { productId: product.id },
        });
      } else {
        console.log("unknown schoolFormType");
      }
    }
  }
};
</script>